


































import { Component, Ref, Vue, Watch } from 'vue-property-decorator'
import PaginationRequest from '@/common/pagination/entities/pagination-request'
import clientConfigService from '@/clients/services/client-config-service'
import pushService from '@/clients/services/push-service'
import snacks from '@/app/services/snacks'
import isEqual from 'lodash/isEqual'
import ClientConfig from '@/clients/entities/client-config'
import ClientConfigFilter from '@/clients/entities/client-config-filter'
import ClientConfigDialog from '@/clients/components/client-config-dialog.vue'
import SendPushDialog from '@/clients/components/send-push-dialog.vue'
import PushMessage from '@/clients/entities/push-message'

@Component
export default class Clients extends Vue {
  @Ref()
  private dialog!: ClientConfigDialog

  @Ref()
  private pushDialog!: SendPushDialog

  private loading: boolean = false
  private configs: ClientConfig[] = []
  private filter: ClientConfigFilter = new ClientConfigFilter()

  @Watch('filter.paging')
  private async filterPagingChanged(
    val: PaginationRequest,
    old: PaginationRequest
  ) {
    if (isEqual(val, old) === false) {
      await this.fetchAll()
    }
  }

  private async fetchAll(resetPage = false) {
    this.loading = true
    if (resetPage) {
      this.filter.paging.page = 1
    }
    const response = await clientConfigService.findAllFilteredAsync(this.filter)
    this.configs = response.items
    this.filter.paging.totalItems = response.totalItems
    this.loading = false
  }

  private openNew() {
    this.dialog.openNew(new ClientConfig())
  }

  private openEdit(config: ClientConfig) {
    this.dialog.openEdit(config)
  }

  private async openSend(config: ClientConfig) {
    this.pushDialog.open(config)
  }

  private async send(config: ClientConfig, message: PushMessage) {
    await pushService.sendAsync(config, message)
    snacks.success(this.$tc('clients.pages.clients.send.success'))
  }

  private async create(config: ClientConfig) {
    await clientConfigService.createAsync(config)
    await this.fetchAll()
  }

  private async update(config: ClientConfig) {
    await clientConfigService.updateAsync(config)
    await this.fetchAll()
  }

  private async remove(config: ClientConfig) {
    await clientConfigService.removeAsync(config.clientId)
    await this.fetchAll()
  }

  private async migrate(config: ClientConfig) {
    this.loading = true
    await clientConfigService.migrate(config.clientId)
    snacks.success(
      'Die Firebase Registrierungen wurde erfolgreich zum Api V1 migriert.'
    )
    this.loading = false
    await this.fetchAll()
  }
}
